/**
 * Thomas Hobbs Florist - Promotional Popup
 * Shows promo code popup once every 24 hours
 */

$(document).ready(function() {
    
    // Configuration
    const POPUP_STORAGE_KEY = 'thomashobbsPromoPopupLastShown';
    const HOURS_BETWEEN_SHOWS = 24;
    const POPUP_DELAY = 1000; // Show popup after 1 second
    
    // Popup HTML markup
    const popupHTML = `
    <div id="promoPopup" class="popup-overlay">
        <div class="popup-container">
            <button class="popup-close" id="closePopup">&times;</button>
            
            <div class="popup-content">
                <div class="flower-decoration">
                    <div class="flower flower-1">🌸</div>
                    <div class="flower flower-2">🌺</div>
                    <div class="flower flower-3">🌼</div>
                    <div class="flower flower-4">🌻</div>
                </div>
                
                <div class="popup-header">
                    <h2 class="popup-title">🌹 Special Offer 🌹</h2>
                    <p class="popup-subtitle">Bloom into Savings!</p>
                </div>
                
                <div class="popup-body">
                    <div class="promo-badge">
                        <div class="badge-label">Use Promo Code</div>
                        <div class="promo-code" id="promoCode">FREESHIP</div>
                        <button class="copy-btn" id="copyCode">
                            <span class="copy-text">Copy Code</span>
                            <span class="copied-text">Copied! ✓</span>
                        </button>
                    </div>
                    
                    <div class="offer-details">
                        <p class="offer-text">
                            🚚 <strong>FREE SHIPPING</strong> on orders over <strong>$100</strong>
                        </p>
                        <p class="offer-subtext">
                            Valid on all fresh flowers and arrangements
                        </p>
                    </div>
                    
                    <a href="#shop" class="cta-button">Shop Now</a>
                </div>
                
                <div class="popup-footer">
                    <small>*Offer valid for online orders only. Terms & conditions apply.</small>
                </div>
            </div>
        </div>
    </div>
    `;
    
    // Inject popup HTML into the page
    $('body').prepend(popupHTML);
    
    /**
     * Check if popup should be shown based on 24-hour rule
     */
    function shouldShowPopup() {
        const lastShown = localStorage.getItem(POPUP_STORAGE_KEY);
        
        if (!lastShown) {
            return true; // Never shown before
        }
        
        const lastShownTime = new Date(lastShown);
        const currentTime = new Date();
        const hoursSinceLastShown = (currentTime - lastShownTime) / (1000 * 60 * 60);
        
        return hoursSinceLastShown >= HOURS_BETWEEN_SHOWS;
    }
    
    /**
     * Show the popup with animation
     */
    function showPopup() {
        $('#promoPopup').addClass('active');
        $('body').css('overflow', 'hidden'); // Prevent scroll while popup is open
        
        // Record the time popup was shown
        localStorage.setItem(POPUP_STORAGE_KEY, new Date().toISOString());
    }
    
    /**
     * Hide the popup with animation
     */
    function hidePopup() {
        $('#promoPopup').removeClass('active');
        $('body').css('overflow', ''); // Restore scroll
    }
    
    /**
     * Copy promo code to clipboard
     */
    function copyPromoCode() {
        const promoCode = $('#promoCode').text();
        
        // Modern clipboard API
        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(promoCode).then(function() {
                showCopySuccess();
            }).catch(function(err) {
                // Fallback if clipboard API fails
                fallbackCopyToClipboard(promoCode);
            });
        } else {
            // Fallback for older browsers
            fallbackCopyToClipboard(promoCode);
        }
    }
    
    /**
     * Fallback copy method for older browsers
     */
    function fallbackCopyToClipboard(text) {
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        
        try {
            document.execCommand('copy');
            showCopySuccess();
        } catch (err) {
            console.error('Failed to copy text: ', err);
            alert('Failed to copy code. Please copy manually: ' + text);
        }
        
        document.body.removeChild(textArea);
    }
    
    /**
     * Show visual feedback when code is copied
     */
    function showCopySuccess() {
        const $copyBtn = $('#copyCode');
        $copyBtn.addClass('copied');
        
        // Reset button after 2 seconds
        setTimeout(function() {
            $copyBtn.removeClass('copied');
        }, 2000);
    }
    
    /**
     * Initialize popup on page load
     */
    function initPopup() {
        if (shouldShowPopup()) {
            setTimeout(function() {
                showPopup();
            }, POPUP_DELAY);
        }
    }
    
    // Event Listeners
    
    // Close popup when X button is clicked
    $('#closePopup').on('click', function() {
        hidePopup();
    });
    
    // Close popup when clicking outside the popup container
    $('#promoPopup').on('click', function(e) {
        if ($(e.target).is('#promoPopup')) {
            hidePopup();
        }
    });
    
    // Close popup with Escape key
    $(document).on('keydown', function(e) {
        if (e.key === 'Escape' && $('#promoPopup').hasClass('active')) {
            hidePopup();
        }
    });
    
    // Copy promo code button
    $('#copyCode').on('click', function(e) {
        e.preventDefault();
        copyPromoCode();
    });
    
    // Click on promo code to copy
    $('#promoCode').on('click', function() {
        copyPromoCode();
        $(this).css('cursor', 'pointer');
    });
    
    // Add pointer cursor hint on hover
    $('#promoCode').hover(
        function() {
            $(this).css('cursor', 'pointer');
        }
    );
    
    // Shop Now button - close popup
    $('.cta-button').on('click', function() {
        hidePopup();
        // The actual navigation will happen via the href
    });
    
    // Initialize the popup system
    initPopup();
    
    // Debugging function (for testing - remove in production)
    // Uncomment the following to reset the popup timer for testing
    /*
    window.resetPopupTimer = function() {
        localStorage.removeItem(POPUP_STORAGE_KEY);
        console.log('Popup timer reset. Refresh the page to see the popup again.');
    };
    */
    
});
